import * as React from 'react'
import './ErrorPanel.scss'

const InviteCodeExpiredAndResent = () => {
  return (
    <div className='h-50 d-flex align-items-center'>
      <div className='auth-popup-container panel-width-480'>
        <div className='auth-popup-inner auth-popup-invitation-code-expired'>
          <div className='auth-popup-invitation-code-expired-logo'>
            <div className='bi bi-envelope-check' />
          </div>
          <div className='auth-popup-content'>
            <span className='auth-popup-title'>New invitation sent</span>
            <span className='auth-popup-text'>
              Your invitation link has expired, but no worries! Zocks just sent a fresh link to your email. Check your inbox, click the link and you'll be all
              set.
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InviteCodeExpiredAndResent
